module.exports = __webpack_public_path__ + "static/media/img2.82e30e38.png";